module.exports = __webpack_public_path__ + "img/hr-tree-03-d-trunk.c2b3698e.png";